


const CornerCheck = ({ className = 'SimpleSwitch__icon' }) => {
    return <svg
        className={className}
        width={18}
        height={18}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M-0.000488281 0H17.1424V14.5714C17.1424 16.465 15.6073 18 13.7138 18H-0.000488281V0Z"
            fill="black"
        />
        <path
            d="M4.99951 8.57139L7.99951 11.1428L12.8569 6"
            stroke="white"
            strokeWidth="0.857143"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
}

export default CornerCheck